"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.counterLabel = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _Button = require("./Button.style");

var sizeStyles = function sizeStyles(props) {
  if (props.size === 'medium') {
    return (
      /*#__PURE__*/
      (0, _reactEmotion.css)("min-width:90px;height:32px;padding:0px 24px 0 18px;font-size:14px;letter-spacing:0.3px;font-weight:600;")
    );
  }

  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("min-width:120px;height:40px;padding:0px 24px;letter-spacing:0.3px;font-weight:600;")
  );
};

var greyButtonColors = {
  grey: 'grey2',
  black: 'black3',
  accentHover: 'accentHover',
  accentClicked: 'accentClicked',
  accent: 'accent'
};

var typeStyles = function typeStyles(_ref) {
  var color = _ref.theme.color,
      disabled = _ref.disabled,
      filterOpen = _ref.filterOpen,
      cssStyle = _ref.cssStyle;
  // const greyButtonColor = greyButtonColors[status];
  var activeStyleRules = "\n    color: ".concat(color[greyButtonColors.accentClicked], ";\n    fill: ").concat(color[greyButtonColors.accentClicked], ";\n    border-color: ").concat(color[greyButtonColors.accentClicked], ";\n    border-style: solid;\n    box-shadow: none;\n  ");
  var activeStyle =
  /*#__PURE__*/
  (0, _reactEmotion.css)(activeStyleRules);
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("color:", color[greyButtonColors.accent], ";fill:", color[greyButtonColors.accent], ";border-radius:4px;border:solid 1px ", color[greyButtonColors.accent], ";", cssStyle, "\n\n    ", filterOpen && activeStyle, "\n\n    ", disabled || "\n      &:hover {\n        color: ".concat(color[greyButtonColors.accent], ";\n        fill: ").concat(color[greyButtonColors.accent], ";\n        border-color: ").concat(color[greyButtonColors.accentHover], ";\n        background-color: ").concat(color[greyButtonColors.accent + 'Highlight'], ";\n      }\n\n      &:active {\n        ").concat(activeStyleRules, "\n      }\n    "))
  );
};

var counterLabel = function counterLabel(_ref2, size) {
  var color = _ref2.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("background-color:", color[greyButtonColors.accent], ";border-radius:50%;height:", size === 'medium' ? '16px' : '20px', ";width:", size === 'medium' ? '16px' : '20px', ";color:#fff;font-size:", size === 'medium' ? '10px' : '12px', ";display:flex;flex-direction:row;align-items:center;justify-content:center;margin-left:6.5px;")
  );
};

exports.counterLabel = counterLabel;

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("button", {
  target: "css-4s4q0h0"
})(_Button.buttonStyles, "\n    ", sizeStyles, "\n    ", typeStyles, "\n    border-radius:4px;"));

exports.default = _default;